import React from "react";
import { Form } from "antd";
import NumberFormat from "react-number-format";

import "./TimeInput.scss";

const rootUrl = process.env.REACT_APP_URI;

const TimeInput = ({
  placeholder,
  className,
  name,
  label,
  value,
  required,
  suffixIcon = true,
  styleInput = { width: "100%" },
  styleForm = {},
  onChange,
  checkValidate,
  hintText,
}) => {
  const isValidTime = value => {
    // const regex = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
    // Existing many cases with time > 24:00 because of route plan processing
    const regex = /^([0-9]{2}):[0-5][0-9]$/;
    return regex.test(value);
  };

  const checkValidateTime = value => {
    if (!checkValidate) return { isValid: true };
    return checkValidate(value);
  };

  return (
    <Form.Item
      className={`TimeInput ${suffixIcon && "suffixIcon"}`}
      label={label}
      name={name}
      rules={[
        { required: required, message: "Required" },
        {
          validator: (_, value) => {
            if (value && !isValidTime(value)) {
              return Promise.reject(new Error("Invalid"));
            }
            const { isValid, message } = checkValidateTime(value);
            if (value && !isValid) {
              return Promise.reject(new Error(message));
            }
            return Promise.resolve();
          },
        },
      ]}
      style={styleForm}>
      <div>
        {suffixIcon && <img src={`${rootUrl}/icons/time.svg`} alt="Time" />}
        <NumberFormat
          placeholder={placeholder}
          className={className}
          style={styleInput}
          format="##:##"
          value={value}
          onValueChange={value => onChange && onChange(value.formattedValue)}
        />
        {hintText && <div className="hint">{hintText}</div>}
      </div>
    </Form.Item>
  );
};

export default TimeInput;
